module.exports = __webpack_public_path__ + "static/19-8e3a86d110ac4996a3c6584ff063b402.jpg";